"use client";

import { Switch } from "@kyan/ui";

import { useTradeDirection } from "#/store/options/page/tradeDirection";

export const TradeDirectionSwitch: React.FC = () => {
  const { tradeDirection, setTradeDirection } = useTradeDirection();

  return (
    <Switch
      type="market"
      className="md:hidden"
      value={tradeDirection}
      onChange={setTradeDirection}
    />
  );
};
